import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import Offset from '../organisms/Offset';
import Select from '../atoms/Select';
import Button from '../atoms/Button';
import Icon from '../atoms/Icon';
import styles from '../../styles/components/organisms/TabBox.module.scss';

interface TabBoxProps {
  className?: string;
  children?: any;
  onChange?: (el: any) => void;
  isOpen?: boolean;
  bg?: boolean;
  toggle?: boolean;
  select?: boolean;
  mobileSelect?: boolean;
  scroll?: boolean;
  offset?: boolean;
  title?: string;
  hl?: string | boolean;
  slide?: boolean;
  tab?: string;
  full?: boolean;
  mobileSlide?: boolean;
  tabForce?: boolean;
  tabs: {
    id: string;
    label: string;
    icon?: string;
    add?: any;
    iconLeft?: boolean;
  }[];
}

export default function TabBox(props: TabBoxProps) {
  const {
    tabs,
    onChange,
    offset,
    mobileSelect,
    mobileSlide,
    isOpen,
    slide,
    title,
    hl,
    full,
    bg,
    toggle,
    scroll,
    select,
    tabForce,
    tab,
    children,
    className,
  } = props;
  const [open, setOpen] = useState() as any;
  const [currTab, setCurrTab] = useState('');
  const curr = tabs.filter((el) => el.id === currTab)[0];
  const classes = clsx(
    styles.tabBox,
    { [styles.bg]: bg },
    { [styles.mobileSelect]: !!mobileSelect },
    { [styles.toggle]: !!toggle },
    { [styles.slide]: !!slide },
    { [styles.full]: full },
    { [styles.mobileSlide]: !!mobileSlide },
    { [styles.scroll]: !!scroll || !!bg },
    { [styles.open]: !!open || !toggle },
    { [styles.offset]: !!offset },
    className
  );

  const toggleState = () => {
    setOpen(!open);
    if (currTab) {
      setCurrTab('');
    } else {
      setCurrTab(tabs[0].id);
    }
  };

  const toggleTab = (id: string) => {
    if (toggle && id === currTab) {
      setOpen(false);
      setCurrTab('');
    } else {
      setCurrTab(id);
    }
  };

  const selectTab = (e: any) => {
    setCurrTab(e.target.value);
  };

  useEffect(() => {
    if (!currTab && !toggle && !!tabs.length) {
      setCurrTab(tabs[0].id);
      setOpen(true);
    } else {
      setOpen(isOpen);
    }
  }, [isOpen, currTab, tabs, toggle]);

  useEffect(() => {
    if (currTab) {
      setOpen(true);
    }
    if (!!onChange && (toggle || currTab)) {
      onChange(currTab);
    }
  }, [currTab, onChange, toggle]);

  useEffect(() => {
    if (!!tab && currTab !== tab) {
      setCurrTab(tab);
    }
  }, [tab, currTab]);

  return (
    <div className={classes}>
      {toggle && <Button white icon={'close'} onClick={toggleState} />}

      {!!title && ( //!!tabs.length &&
        <h2>{title}</h2>
      )}

      {(tabs.length > 1 || tabForce) && (
        <div>
          {(select || mobileSelect) && (
            <Select
              className={styles.tabSelect}
              grey={bg}
              onChange={selectTab}
              options={tabs.map((el, id) => ({
                label: el.label,
                value: el.id,
              }))}
            />
          )}
          {!select &&
            tabs.map((el, i) => {
              const add = el.icon === 'add';
              const btnClass = clsx(
                styles.tabBtn,
                { [styles.dashed]: add },
                className
              );
              return (
                <Button
                  key={`tab-${i}`}
                  className={btnClass}
                  toggle
                  float
                  transparent={bg}
                  colored
                  iconFill={!add}
                  onClick={() => toggleTab(el.id)}
                  active={currTab === el.id}
                  disabled={!toggle && currTab === el.id}
                  label={el.label}
                  icon={el.icon}
                  iconLeft={el.iconLeft}
                  add={el.add}
                />
              );
            })}
        </div>
      )}
      <div>
        {curr && !!hl && (
          <h3>
            <span>{typeof hl === 'string' ? hl : curr.label}</span>
            {curr.icon && <Icon name={curr.icon} />}
            {curr.add && <span>{curr.add}</span>}
          </h3>
        )}
        {offset ? <Offset>{children}</Offset> : <div>{children}</div>}
      </div>

      {toggle && (
        <Button icon={open ? 'arrow-up' : 'arrow-down'} onClick={toggleState} />
      )}
    </div>
  );
}
